"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = require("../helpers/parse");
var TabsCollection = /** @class */ (function (_super) {
    __extends(TabsCollection, _super);
    function TabsCollection(externalButton, appState, preview, testFeatures, profanityFilter, scroller, $timeout, tabs, enableAll) {
        var _this = _super.call(this) || this;
        _this.externalButton = externalButton;
        _this.appState = appState;
        _this.preview = preview;
        _this.testFeatures = testFeatures;
        _this.profanityFilter = profanityFilter;
        _this.scroller = scroller;
        _this.$timeout = $timeout;
        _this.formsWithHiddenOptions = [];
        _this.index = 0;
        _this.book = {};
        // https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
        Object.setPrototypeOf(_this, TabsCollection.prototype);
        for (var _i = 0, tabs_1 = tabs; _i < tabs_1.length; _i++) {
            var tab = tabs_1[_i];
            if (tab.order && isNaN(tab.order)) {
                tab.order = parse_1.evaluateCondition(tab.order, {
                    hasFeature: testFeatures.hasFeature,
                    testFeatures: testFeatures.testFeatures
                });
            }
        }
        tabs.sort(function (a, b) {
            if (a.order > b.order) {
                return 1;
            }
            if (a.order < b.order) {
                return -1;
            }
            return 0;
        });
        tabs.forEach(function (config, index) {
            var tab = new Tab(config, _this, preview, enableAll, index);
            _this.push(tab);
        });
        _this.setActive(_this[0]);
        return _this;
    }
    TabsCollection.prototype.setBook = function (book) {
        this.book = book;
    };
    TabsCollection.prototype.getIndex = function () {
        var current = this.index;
        this.index++;
        return current;
    };
    TabsCollection.prototype.getGlobalIndex = function () {
        var globalIndex, index = 0;
        for (var t = index; t < this.length; t++) {
            if (!this[t].isVisible) {
                continue;
            }
            if (!this[t].tabs.length) {
                if (this[t] === this.activeTab) {
                    globalIndex = index;
                    break;
                }
                index++;
            }
            else {
                for (var s = 0; s < this[t].tabs.length; s++) {
                    if (this[t].tabs[s] === this.activeSubTab) {
                        globalIndex = index;
                        break;
                    }
                    index++;
                }
            }
            if (globalIndex !== undefined) {
                break;
            }
        }
        return globalIndex;
    };
    TabsCollection.prototype.getActive = function () {
        return this.activeTab.id;
    };
    TabsCollection.prototype.getActiveSubTab = function () {
        return this.activeSubTab;
    };
    TabsCollection.prototype.getSubTabIndex = function () {
        return this.activeSubTab ? this.activeSubTab.subIndex : 0;
    };
    TabsCollection.prototype.isActive = function (tab) {
        return tab === this.activeSubTab || tab === this.activeTab;
    };
    TabsCollection.prototype.setActive = function (tab, enableValidation) {
        if (enableValidation === void 0) { enableValidation = false; }
        return __awaiter(this, void 0, void 0, function () {
            var mainTab, subTab, currentTab, currentIndex, targetIndex, profanityFilterMatches, profanityFilterResults_2, _i, _a, form, _loop_1, _b, profanityFilterResults_1, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        mainTab = tab instanceof SubTab ? tab.parent : tab, subTab = tab instanceof SubTab ? tab : tab.tabs.length ? tab.tabs[0] : undefined, currentTab = this.activeSubTab || this.activeTab, currentIndex = currentTab ? currentTab.globalIndex : undefined, targetIndex = subTab ? subTab.globalIndex : mainTab.globalIndex, profanityFilterMatches = [];
                        if (!(currentIndex < targetIndex)) return [3 /*break*/, 2];
                        if (!this.tabIsValid() && !this.appState.debug) {
                            currentTab.enableValidation();
                            this.appState.appCtrl.showValidationDialog('required');
                            this.scroller.scrollTo(this.appState.screen.isMobile ? '#pb-scroll-form' : '#pb-scroll-top');
                            this.showInvalidFormOptions();
                            return [2 /*return*/, this.$timeout(function () { return Promise.resolve(false); })];
                        }
                        if (!(this.appState.profanityFilter && currentTab && currentTab.formsWithProfanityFilter.length)) return [3 /*break*/, 2];
                        profanityFilterResults_2 = [];
                        for (_i = 0, _a = currentTab.formsWithProfanityFilter; _i < _a.length; _i++) {
                            form = _a[_i];
                            form.showProfanityValidation(false);
                        }
                        return [4 /*yield*/, this.profanityFilter.checkForms(currentTab.formsWithProfanityFilter, this.book).then(function (value) {
                                profanityFilterResults_2 = value;
                            })];
                    case 1:
                        _c.sent();
                        profanityFilterResults_2 = profanityFilterResults_2.filter(function (result) { return result.matches.length; });
                        _loop_1 = function (result) {
                            var matchedForm = currentTab.formsWithProfanityFilter.find(function (form) { return form.id === result.id; });
                            matchedForm.showProfanityValidation();
                            for (var _i = 0, _a = result.matches; _i < _a.length; _i++) {
                                var match = _a[_i];
                                profanityFilterMatches.push(match);
                            }
                        };
                        for (_b = 0, profanityFilterResults_1 = profanityFilterResults_2; _b < profanityFilterResults_1.length; _b++) {
                            result = profanityFilterResults_1[_b];
                            _loop_1(result);
                        }
                        if (profanityFilterMatches.length) {
                            this.appState.appCtrl.showProfanityDialog(profanityFilterMatches);
                            this.scroller.scrollTo(this.appState.screen.isMobile ? '#pb-scroll-form' : '#pb-scroll-top');
                            return [2 /*return*/, this.$timeout(function () { return Promise.resolve(false); })];
                        }
                        _c.label = 2;
                    case 2:
                        if (currentTab) {
                            currentTab.enableValidation(false);
                            this.appState.navigated = true;
                            this.scroller.scrollTo(enableValidation && this.appState.screen.isMobile ? '#pb-scroll-form' : '#pb-scroll-top');
                        }
                        this.activeTab = mainTab;
                        this.activeSubTab = subTab;
                        mainTab.enable();
                        mainTab.enableValidation(enableValidation);
                        if (subTab) {
                            subTab.enable();
                            subTab.enableValidation(enableValidation);
                        }
                        this.updateTabs();
                        this.appState.currentTab = subTab || mainTab;
                        this.preview.setActiveTab(subTab || mainTab);
                        return [2 /*return*/, this.$timeout(function () { return Promise.resolve(true); })];
                }
            });
        });
    };
    TabsCollection.prototype.updateTabs = function () {
        var invalid = false, allEnabled = true;
        for (var _i = 0, _a = this; _i < _a.length; _i++) {
            var tab = _a[_i];
            tab.enable(invalid ? false : tab.tabWasEnabled());
            tab.isVisible = tab.condition ? parse_1.evaluateCondition(tab.condition, this.book) : true;
            if (tab.isVisible && !tab.tabIsEnabled()) {
                allEnabled = false;
            }
            if (tab.isVisible && !tab.tabs.length && !tab.isValid()) {
                invalid = true;
            }
            for (var _b = 0, _c = tab.tabs; _b < _c.length; _b++) {
                var subTab = _c[_b];
                subTab.enable(invalid ? false : subTab.tabWasEnabled());
                if (!subTab.tabIsEnabled()) {
                    allEnabled = false;
                }
                if (!subTab.isValid()) {
                    invalid = true;
                }
            }
        }
        if (allEnabled && !this.appState.sendMail) {
            this.appState.basketEnabled = true;
            this.externalButton.enable();
        }
    };
    TabsCollection.prototype.getSubTabCount = function () {
        var tab = this.activeTab;
        return tab.tabs ? tab.tabs.length : 0;
    };
    TabsCollection.prototype.getTabCount = function () {
        var count = 0;
        for (var _i = 0, _a = this; _i < _a.length; _i++) {
            var tab = _a[_i];
            if (tab.tabs.length === 0 && tab.isVisible) {
                count++;
            }
            for (var _b = 0, _c = tab.tabs; _b < _c.length; _b++) {
                var subTab = _c[_b];
                count++;
            }
        }
        return count;
    };
    TabsCollection.prototype.findTab = function (id, group) {
        var tab;
        if (group) {
            var groupTabs = this.find(function (tab) { return tab.id === group; }).tabs;
            tab = groupTabs.find(function (tab) { return tab.id === id; });
        }
        else {
            tab = this.find(function (tab) { return tab.id === id; });
        }
        return tab;
    };
    TabsCollection.prototype.setNextTab = function () {
        return __awaiter(this, void 0, void 0, function () {
            var index, tab, subIndex, success, nextTab, i, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        index = this.findIndex(function (tab) { return tab.id === _this.activeTab.id; }), tab = this[index], subIndex = tab.tabs.findIndex(function (subTab) { return subTab.id === _this.activeSubTab.id; }), success = false;
                        if (!(subIndex >= 0 && subIndex < tab.tabs.length - 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setActive(tab.tabs[subIndex + 1])];
                    case 1:
                        success = _b.sent();
                        return [3 /*break*/, 8];
                    case 2:
                        if (!(index < this.length - 1)) return [3 /*break*/, 8];
                        nextTab = void 0;
                        for (i = index + 1; i < this.length; i++) {
                            if (this[i].isVisible) {
                                nextTab = this[i];
                                break;
                            }
                        }
                        if (!(nextTab && nextTab.tabs.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setActive(nextTab.tabs[0])];
                    case 3:
                        success = _b.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!nextTab) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.setActive(nextTab)];
                    case 5:
                        _a = _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _a = false;
                        _b.label = 7;
                    case 7:
                        success = _a;
                        _b.label = 8;
                    case 8: return [2 /*return*/, success];
                }
            });
        });
    };
    TabsCollection.prototype.setPrevTab = function () {
        return __awaiter(this, void 0, void 0, function () {
            var index, tab, subIndex, success, prevTab, i, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        index = this.findIndex(function (tab) { return tab.id === _this.activeTab.id; }), tab = this[index], subIndex = tab.tabs.findIndex(function (subTab) { return subTab.id === _this.activeSubTab.id; }), success = false;
                        if (!(subIndex > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setActive(tab.tabs[subIndex - 1])];
                    case 1:
                        success = _b.sent();
                        return [3 /*break*/, 8];
                    case 2:
                        if (!(index > 0)) return [3 /*break*/, 8];
                        prevTab = void 0;
                        for (i = index - 1; i >= 0; i--) {
                            if (this[i].isVisible) {
                                prevTab = this[i];
                                break;
                            }
                        }
                        if (!(prevTab && prevTab.tabs.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setActive(prevTab.tabs[prevTab.tabs.length - 1])];
                    case 3:
                        success = _b.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!prevTab) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.setActive(prevTab)];
                    case 5:
                        _a = _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _a = false;
                        _b.label = 7;
                    case 7:
                        success = _a;
                        _b.label = 8;
                    case 8: return [2 /*return*/, success];
                }
            });
        });
    };
    TabsCollection.prototype.showInvalidTab = function () {
        var targetTab;
        for (var _i = 0, _a = this; _i < _a.length; _i++) {
            var tab = _a[_i];
            if (targetTab) {
                break;
            }
            if (!tab.tabs.length && !tab.isValid()) {
                targetTab = tab;
            }
            for (var _b = 0, _c = tab.tabs; _b < _c.length; _b++) {
                var subTab = _c[_b];
                if (!subTab.isValid()) {
                    targetTab = subTab;
                    break;
                }
            }
        }
        if (targetTab) {
            this.setActive(targetTab, true);
            this.showInvalidFormOptions();
        }
    };
    TabsCollection.prototype.showProfaneTab = function (formId) {
        var targetTab = null;
        for (var _i = 0, _a = this; _i < _a.length; _i++) {
            var tab = _a[_i];
            if (tab instanceof Tab && tab.formsWithProfanityFilter.find(function (form) { return form.id === formId; })) {
                targetTab = tab;
                break;
            }
            for (var _b = 0, _c = tab.tabs; _b < _c.length; _b++) {
                var subTab = _c[_b];
                if (subTab.formsWithProfanityFilter.find(function (form) { return form.id === formId; })) {
                    targetTab = subTab;
                    break;
                }
            }
        }
        if (targetTab) {
            this.setActive(targetTab, true);
        }
    };
    TabsCollection.prototype.showfirstTab = function () {
        this.setActive(this[0]);
    };
    TabsCollection.prototype.tabIsValid = function () {
        if (!this.activeTab) {
            return true;
        }
        var currentTab = this.activeSubTab || this.activeTab;
        return currentTab.isValid();
    };
    TabsCollection.prototype.showInvalidFormOptions = function () {
        for (var _i = 0, _a = this.formsWithHiddenOptions; _i < _a.length; _i++) {
            var form = _a[_i];
            form.showInvalidFormOption();
        }
    };
    return TabsCollection;
}(Array));
exports.TabsCollection = TabsCollection;
var Tab = /** @class */ (function () {
    function Tab(config, collection, preview, enabled, index) {
        this.collection = collection;
        this.preview = preview;
        this.isVisible = true;
        this.overlay = true;
        this.formsWithProfanityFilter = [];
        this.validated = false;
        this.id = config.id;
        this.condition = config.condition;
        this.isEnabled = enabled;
        this.wasEnabled = enabled;
        this.icon = config.icon;
        this.tabs = this.createSubTabs(config.tabs);
        this.previewPage = this.tabs.length ? this.tabs[0].previewPage : config.previewPage;
        this.title = config.title;
        this.errors = {};
        this.tabIndex = index;
        if (typeof config.previewPage === 'string') {
            // previewPage defined by condition
            this.$previewPage = config.previewPage;
        }
        if (!this.tabs.length) {
            this.globalIndex = collection.getIndex();
        }
    }
    Tab.prototype.createSubTabs = function (subTabs) {
        var _this = this;
        var parent = this;
        var tabs = [];
        subTabs = subTabs ? subTabs : [];
        subTabs.forEach(function (config, index) {
            var tab = new SubTab(config, parent, _this.collection, _this.isEnabled, _this.preview, index);
            tabs.push(tab);
        });
        return tabs;
    };
    Tab.prototype.showOverlay = function () {
        var show = this.overlay;
        this.overlay = false;
        return show;
    };
    Tab.prototype.hasSub = function () {
        return !!(this.tabs.length);
    };
    Tab.prototype.tabWasEnabled = function () {
        return this.wasEnabled;
    };
    Tab.prototype.tabIsEnabled = function () {
        return this.isActive() || this.isEnabled;
    };
    Tab.prototype.enable = function (enable) {
        if (enable === void 0) { enable = true; }
        this.isEnabled = enable !== false;
        if (enable) {
            this.wasEnabled = true;
        }
    };
    Tab.prototype.enableValidation = function (enable) {
        if (enable === void 0) { enable = true; }
        this.validated = enable !== false;
    };
    Tab.prototype.isValidationEnabeled = function () {
        if (!this.isActive()) {
            return false;
        }
        var subTab = this.collection.getActiveSubTab();
        return subTab ? subTab.validated && subTab.isInvalid() : this.validated;
    };
    Tab.prototype.setValidity = function (key, valid) {
        if (valid === false) {
            this.errors[key] = valid;
        }
        else {
            delete this.errors[key];
        }
        this.collection.updateTabs();
    };
    Tab.prototype.isValid = function (key) {
        if (!this.isVisible) {
            return true;
        }
        return key ? !(key in this.errors) : Object.entries(this.errors).length < 1;
    };
    Tab.prototype.isInvalid = function (key) {
        return !this.isValid(key);
    };
    Tab.prototype.isActive = function () {
        return this.collection.isActive(this);
    };
    Tab.prototype.setActive = function () {
        this.collection.setActive(this);
    };
    return Tab;
}());
exports.Tab = Tab;
var SubTab = /** @class */ (function (_super) {
    __extends(SubTab, _super);
    function SubTab(config, parent, collection, enabled, preview, index) {
        var _this = _super.call(this, config, collection, preview, enabled, index) || this;
        _this.subIndex = index;
        _this.parent = parent;
        _this.group = _this.parent.id + '.' + _this.id;
        return _this;
    }
    SubTab.prototype.isValidationEnabeled = function () {
        return this.validated;
    };
    SubTab.prototype.getActive = function () {
        return this.collection.getActiveSub();
    };
    SubTab.prototype.isActive = function () {
        return this.collection.isActive(this);
    };
    SubTab.prototype.setActive = function () {
        this.collection.setActive(this);
    };
    SubTab.prototype.hasSub = function () {
        return false;
    };
    return SubTab;
}(Tab));
exports.SubTab = SubTab;
exports.default = TabsCollection;
